import { render } from "./ProjectCatalogSearch.vue?vue&type=template&id=62a0c77c&ts=true&lang=pug"
import script from "./ProjectCatalogSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCatalogSearch.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__